import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const getDetailCompanyServicesStatus = createAsyncThunk('/dashboard_detail_company_services_status/content', async (id) => {
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/detailCompanyGoodsServiceStatusDash/${id}`, {})
    return response.data;
})

export const dashboardDetailCompanyServicesStatusSlice = createSlice({
    name: 'dashboard_detail_company_services_status',
    initialState: {
        isLoading: false,
        dashboard_detail_company_services_status: []
    },

    /*extraReducers: {
        [getDetailCompanyServicesStatus.pending]: state => {
            state.isLoading = true
        },
        [getDetailCompanyServicesStatus.fulfilled]: (state, action) => {
            state.dashboard_detail_company_services_status = action.payload.data
            state.isLoading = false
        },
        [getDetailCompanyServicesStatus.rejected]: state => {
            state.isLoading = false
        },
    }*/
    extraReducers: (builder) => {
        builder
            .addCase(getDetailCompanyServicesStatus.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getDetailCompanyServicesStatus.fulfilled, (state, action) => {
                state.dashboard_detail_company_services_status = action.payload.data;
                state.isLoading = false;
            })
            .addCase(getDetailCompanyServicesStatus.rejected, (state) => {
                state.isLoading = false;
            });
    },  
})

export default dashboardDetailCompanyServicesStatusSlice.reducer